export default "__VITE_ASSET__RGMFA$ek__"